<template>
	<div class="relative flex items-center">
		<div class="flex-1 relative">
			<label
				for="search"
				class="absolute text-gray-600 dark:text-gray-200 ml-4 top-1/2 transform -translate-y-1/2"
			>
				<svg
					id="i-search"
					xmlns="http://www.w3.org/2000/svg"
					viewBox="0 0 32 32"
					width="18"
					height="18"
					fill="none"
					stroke="currentcolor"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="3"
				>
					<circle cx="14" cy="14" r="12" />
					<path d="M23 23 L30 30" />
				</svg>
			</label>
			<input
				id="search"
				type="text"
				class="w-full bg-white dark:bg-gray-600 dark:text-gray-200 py-3 pl-12 pr-4 rounded-md shadow-md outline-none focus:ring ring-green-500 ring-opacity-40"
				:placeholder="`Search ${iconsCount} icons...`"
				v-model="inputVal"
			/>
		</div>
		<label for="decorations" class="toggle-switch">
			<input
				id="decorations"
				type="checkbox"
				@input="$emit('toggleDecorations')"
			/>
			<span for="decoration" class="slider"></span>
			<span for="decorations" class="ml-1 text-gray-600 dark:text-gray-300">
				Decorations
			</span>
		</label>
	</div>
</template>

<script>
export default {
	props: ["value", "iconsCount"],
	computed: {
		inputVal: {
			get() {
				return this.value;
			},
			set(value) {
				this.$emit("input", value);
			},
		},
	},
};
</script>

<style lang="scss" scoped>
.toggle-switch {
	@apply absolute top-1/2 flex ml-3 items-center right-0 mx-4 transform -translate-y-1/2;

	input {
		@apply h-0 w-0 opacity-0;

		&:checked + .slider {
			@apply bg-green-500;

			&::before {
				@apply right-0;
			}
		}
		&:focus + .slider {
			@apply ring ring-green-500 ring-opacity-40;
		}
	}
	.slider {
		@apply relative inline-block rounded-full h-5 w-8 bg-gray-400;

		&::before {
			content: "";
			@apply absolute top-1/2 block mx-1 rounded-full bg-white h-3 w-3 transition-all duration-300 transform -translate-y-1/2;
		}
	}
}
</style>
